export default "__VITE_ASSET__BWvBza1B__"